module.exports = __webpack_public_path__ + "img/teshio_deli_numazu.06eef193.png";